import moment from 'moment';


import { call, fork, all, takeEvery, takeLatest, put, select } from 'redux-saga/effects';

import * as c from '../../constants/constant_action_types';

import { fetchSummaryTypeData, exportSummaryService } from '../../services/store_summary/api_store_summary';
import {
  storeSummaryFetched,
  storeSummaryFetching,
  storeSummaryError
} from '../../actions/actionCreatorStoreSummary';

import {
  immediateDownload
} from '../../actions/actionCreatorsDownloader';
import { getErrorMessage } from '../../utils';

export default function* (app) {
  return yield all([
    fork(fetchSummaryType, app),
    fork(fetchSummaries, app),
    fork(exportSummaries, app)
  ]);
};

function* fetchSummaryType (app) {
  yield takeEvery(c.FETCH_SUMMARY_TYPE_DATA, callFetchSummaryType, app);
}
function* callFetchSummaryType(app, action) {
  const { payload } = action;
  const { summary_type, filters } = payload || {};
  
  try {
    if (filters && filters.date_from) { filters.date_from = moment(filters.date_from).utc().format(); }
    if (filters && filters.date_to) { filters.date_to = moment(filters.date_to).utc().format(); }
    yield put(storeSummaryFetching(summary_type));
    const data = yield call(fetchSummaryTypeData, app, summary_type, filters);
    yield put(storeSummaryFetched({ data, summary_type }));
  } catch (err) {
    yield put(storeSummaryError({ message: getErrorMessage(err), summary_type }));
  }
}

function* fetchSummaries(app) {
  yield takeLatest(c.QUERY_SUMMARIES, callFetchSummaries, app);
}
function* callFetchSummaries(app, action) {
  try {
    const { filters } = action.payload;
    const { store_summary } = yield select();
    const summaryKeys = Object.keys(store_summary);
    const keysLength = summaryKeys.length;
    
    const data = {
      payload: {
        summary_type: '',
        filters: {},
      }
    };

    for ( let k = 0; k < keysLength; k++ ) {
      data.payload.summary_type = summaryKeys[ k ];
      data.payload.filters = { ...filters }
      yield fork(callFetchSummaryType, app, data);
    };
    
  } catch (err) {
    throw err;
  }
};

function* exportSummaries(app) {
  yield takeLatest(c.EXPORT_STORE_SUMMARY_TO_DOC, callExportSummaries, app);
}
function* callExportSummaries(app, action) {
  try {
    const { filters, requestType } = action.payload;
    const { store_summary } = yield select();
    const summaryKeys = Object.keys(store_summary);

    if (filters && filters.date_from) { filters.date_from = moment(filters.date_from).utc().format(); }
    if (filters && filters.date_to) { filters.date_to = moment(filters.date_to).utc().format(); }

    let summaries = '';

    for (const key of summaryKeys) {
      const data = yield call(exportSummaryService, app, key, filters, requestType);
      summaries += data + '\n\n';
    }
  
    yield put(immediateDownload(summaries, true, 'csv', 'store_summary'));
  } catch (err) {
    throw err;
  }
}